import { Radio } from 'antd';
import styled from 'styled-components';

import Typo from '@/components/Typography/Typo';
import useUIStore from '@/stores/pure/UIStore';

import { VFlex } from '../../../components/base';
import SettingHeader from '../Header';

const AppearanceSettingBody = () => {
  const { colorTheme, setColorTheme, systemTheme } = useUIStore((state) => ({
    colorTheme: state.colorMode,
    setColorTheme: state.setColorMode,
    systemTheme: state.systemTheme,
  }));
  return (
    <>
      <SettingHeader title="Appearance" />
      <Wrapper g="16px">
        <Typo type="label2" weight="m">
          Color theme
        </Typo>
        <Radio.Group
          value={colorTheme}
          onChange={(e) => setColorTheme(e.target.value)}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
          }}
        >
          <Radio value="system">System ({systemTheme})</Radio>
          <Radio value="light">Light</Radio>
          <Radio value="dark">Dark</Radio>
        </Radio.Group>
      </Wrapper>
    </>
  );
};

export default AppearanceSettingBody;

const Wrapper = styled(VFlex)`
  width: 100%;
  padding: 32px;
`;
